import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Assets
import Gold from "../../assets/img/brands/gold.png";
import Pado from "../../assets/img/brands/pado.png";
import Yale from "../../assets/img/brands/yale.png";
import Stam from "../../assets/img/brands/stam.png";
import Papaiz from "../../assets/img/brands/papaiz.png";
import LaFonte from "../../assets/img/brands/la-fonte.png";
import Soprano from "../../assets/img/brands/soprano.png"

export default function BrandSlider() {
  const settings = {
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true,
        },
      },
    ],
  };
  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={Gold} alt="marca gold" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={Pado} alt="marca pado" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={Yale} alt="marca yale" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={Stam} alt="marca stam" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={Papaiz} alt="marca papaiz" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={LaFonte} alt="marca la fonte" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={Soprano} alt="marca soprano" />
        </LogoWrapper>
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 100%;
  height: auto;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
const ImgStyle = styled.img`
  width: 100%;
  height: auto;
  padding: 10%;
`;